"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaAccountOrganizationFactory = void 0;
const Factory = require("factory.ts");
const Accounts_1 = require("../Accounts");
const factories_1 = require("../../../UserService/factories");
exports.personaAccountOrganizationFactory = Factory.Sync.makeFactory({
    id: `persona-account-${Factory.each(i => i + 1)}`,
    access: 'viewer',
    relationship: 'other',
    persona_listener_id: null,
    user: Accounts_1.userFactory.build(),
    alert_preferences: factories_1.alertPreferenceFactory.buildList(2)
});
